import React from 'react';
import { IconProps } from './types/Icon.type';

function ArrowLeft32Icon(props: IconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1211 15.9999L19.5302 10.5909C19.823 10.298 19.823 9.82311 19.5302 9.53022C19.2373 9.23732 18.7624 9.23732 18.4695 9.53022L12.5302 15.4695C12.3443 15.6555 12.2764 15.9148 12.3265 16.1543C12.3554 16.2921 12.4233 16.4234 12.5303 16.5304L18.4696 22.4697C18.7625 22.7626 19.2373 22.7626 19.5302 22.4697C19.8231 22.1768 19.8231 21.702 19.5302 21.4091L14.1211 15.9999Z"
        fill={props.fill ?? '#121212'}
      />
    </svg>
  );
}

export default ArrowLeft32Icon;
